import React from "react";
import LoadingComponent from "src/components/General/Loading";
import { PsModal } from "src/components/General/Modal";

import { UpdateAccount } from "./UpdateAccountForm";

export interface UpdateAccountModalProps {
  email: string;
  cb: (newEmail: string) => void;
}

export interface ProfessionalConnectModalMethods {
  showModal(): void;
}

// eslint-disable-next-line react/display-name
export const UpdateAccountModal = React.forwardRef<ProfessionalConnectModalMethods, UpdateAccountModalProps>(
  (props, ref) => {
    const [visible, setVisible] = React.useState(false);

    const [loading, setLoading] = React.useState(true);
    React.useImperativeHandle(ref, () => ({
      showModal(): void {
        setVisible(true);
        setLoading(false);
      },
    }));
    return (
      <>
        <PsModal visible={visible} toggleCb={(): void => setVisible(!visible)} title={"Update Account"}>
          {loading === true && <LoadingComponent />}
          {loading === false && (
            <UpdateAccount
              email={props.email}
              successCb={(newEmail) => {
                props.cb(newEmail);
                setVisible(false);
              }}
            />
          )}
        </PsModal>
      </>
    );
  },
);
